export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">关于小草</h2>
          <p className="text-sm text-foreground-500">了解小草影院的故事与初心。</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-12">
          <div className="max-w-[720px] mx-auto">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
              小草影院诞生于一个简单的想法——让每个人都能轻松看上高清电影。我们是一群热爱影视的年轻人，深知市面上充斥着各种收费会员和满屏广告的观影平台给普通观众带来的困扰。于是我们决定打造一个真正免费、干净、流畅的在线观影平台。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
              自上线以来，小草影院始终坚持"不收费、不注册、不缓冲"的服务理念。我们投入大量资源建设全国 CDN 加速网络，与多家内容合作伙伴建立深度协作，确保用户在任何时间、任何地点都能享受秒开不卡的观影体验。目前平台已积累超过 5 万部影视资源，涵盖电影、电视剧、动漫、纪录片等多种类型。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              小草影院每日更新数百部新内容，拥有数百万活跃用户。我们相信，好的内容应该被更多人看到，而观看的门槛应该尽可能低。未来，我们将继续优化播放体验、丰富内容库，让小草影院成为每一位影视爱好者首选的免费观影平台。观影之路，小草相伴。
            </p>

            <div className="grid grid-cols-3 gap-6 md:gap-10 mt-10 pt-8 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">5万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">350+</div>
                <div className="text-xs text-foreground-500 mt-1">加速节点</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}